var _mask, _g, _g2, _path, _circle, _circle2, _g3, _g4, _path2, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottts1767950117084(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    fill: "none",
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "viewboxMask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#viewboxMask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 66)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sidesAntenna02-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 160,
    height: 51
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 28,
    width: 36,
    height: 32,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 9h2v20h-2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 28,
    width: 36,
    height: 32,
    rx: 4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sidesAntenna02-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h180v76H0V0Z",
    fill: "#43a047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h180v76H0V0Z",
    fill: "#fff",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M0 38h180v38H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.4,
    d: "M160 8h2v20h-2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 5,
    r: 4,
    fill: "#E1E6E8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 4,
    r: 2,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "topLights-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 22,
    width: 80,
    height: 30
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 42c0-1.1.9-2 2-2h76a2 2 0 0 1 2 2v10H10V42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 27a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5v25H18V27ZM42 27a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5v25H42V27ZM66 27a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5v25H66V27Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#topLights-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v52H0V0Z",
    fill: "#43a047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v52H0V0Z",
    fill: "#fff",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.6,
    d: "M0 0h100v40H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 28,
    width: 4,
    height: 8,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 28,
    width: 4,
    height: 8,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 28,
    width: 4,
    height: 8,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.6
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 44)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "faceSquare03-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 130,
    height: 120
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18A18 18 0 0 1 18 0h94a18 18 0 0 1 18 18v27.15a40 40 0 0 1-2.28 13.31L110.24 108a18 18 0 0 1-16.98 12H36.74a18 18 0 0 1-16.98-12L2.28 58.45A40 40 0 0 1 0 45.15V18Z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#faceSquare03-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h134v124H-2V-2Z",
    fill: "#43a047"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(52 124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.05 8.44a2 2 0 1 1 3.9-.88C31.72 10.96 34.4 13 38 13c3.6 0 6.28-2.04 7.05-5.44a2 2 0 1 1 3.9.88C47.75 13.7 43.43 17 38 17s-9.76-3.3-10.95-8.56Z",
    fill: "#000",
    fillOpacity: 0.6
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(38 76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.27 9.68c-2.55.13-4.96 2.24-6.25 4.15-1.48-1.76-4.1-3.6-6.65-3.47-5.48.28-8.85 3.8-8.63 8.1.3 5.72 4.88 8.89 9.7 12.24 1.71 1.15 5 4.15 5.42 4.82.42.67 2.14.6 2.58-.13a37.8 37.8 0 0 1 4.9-5.36c4.43-3.84 8.66-7.47 8.36-13.2-.23-4.3-3.95-7.44-9.43-7.15ZM87.63 10.36c-2.55-.14-5.17 1.7-6.65 3.47-1.3-1.9-3.7-4.02-6.25-4.15-5.48-.29-9.2 2.86-9.43 7.16-.3 5.72 3.93 9.35 8.36 13.19 1.6 1.32 4.55 4.64 4.9 5.36.35.7 2.06.82 2.58.13.51-.7 3.7-3.67 5.42-4.82 4.81-3.35 9.4-6.52 9.7-12.24.22-4.3-3.15-7.82-8.63-8.1Z",
    fill: "#FF5353",
    fillOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottts1767950117084);
export default __webpack_public_path__ + "static/media/bottts-1767950117084.6471926ccf4698f474ca549090b1207c.svg";
export { ForwardRef as ReactComponent };